module.exports = __webpack_public_path__ + "img/solution-finance-img3.bd901b4f.png";